import styled from 'styled-components';

export const WrapperStatus = styled.div`
  display: flex;
  justify-content: center;
`;

export const ContainerStatus = styled.div`
  display: flex;
  align-items: center;
  width: 300px;
`;

export const Status = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 20px;
  height: 30px;
  border-radius: 30px;
  color: #f5f5f5;
  margin-left: 10px;
  margin-right: 5px;
`;
